// src/store/syncStore.ts
import { create } from "zustand";
import api from "../service/api";

export interface SyncConfig {
  integrationType: string;
  integrationConfig: any;
  queries: Array<{ name: string; query: string; targetEndpoint: string }>;
}
interface SyncStore {
  loading: boolean;
  fetchConfig: (firmId: number) => Promise<SyncConfig | null>;
  resetFirmData: (firmId: number) => Promise<{ success: boolean; stats?: any }>; // Yeni fonksiyon
  resetSyncData: (firmId: number) => Promise<{ success: boolean; stats?: any }>; // Yeni fonksiyon
  clearFirmImages: (firmId: number) => Promise<{ success: boolean; stats?: any }>; // Yeni fonksiyon
}

export const useSyncStore = create<SyncStore>((set) => ({
  loading: false,
  fetchConfig: async (firmId: number) => {
    set({ loading: true });
    try {
      const res = await api.get<SyncConfig>(`/sync/config-admin/${firmId}`);
      set({ loading: false });
      return res.data;
    } catch (err) {
      set({ loading: false });
      return null;
    }
  },
  resetFirmData: async (firmId: number) => {
    set({ loading: true });
    try {
      const res = await api.post(`/sync/reset-firm-data/${firmId}`, { confirm: true });
      set({ loading: false });
      return { success: true, stats: res.data.stats };
    } catch (err) {
      set({ loading: false });
      return { success: false };
    }
  }
  ,resetSyncData: async (firmId: number) => {
    set({ loading: true });
    try {
      const res = await api.post(`/sync/reset-sync-data/${firmId}`, { confirm: true });
      set({ loading: false });
      return { success: true, stats: res.data.stats };
    } catch (err) {
      set({ loading: false });
      return { success: false };
    }
  },

  // 2. Sadece Resimleri ve Kotayı Sıfırla
  clearFirmImages: async (firmId: number) => {
    set({ loading: true });
    try {
      const res = await api.post(`/sync/clear-images/${firmId}`, { confirm: true });
      set({ loading: false });
      return { success: true, count: res.data.deletedCount };
    } catch (err) {
      set({ loading: false });
      return { success: false };
    }
  }
}));